import { Controller } from "@hotwired/stimulus"

// One reconcile fetch on connect, deferred a microtask so the surrounding
// turbo_stream_from subscription is live first. Catches any broadcasts the
// page missed before subscribing.
export default class extends Controller {
  static values = { url: String }

  connect() {
    queueMicrotask(() => this.reconcile())
  }

  async reconcile() {
    if (!this.urlValue) return

    const response = await fetch(this.urlValue, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
      credentials: "same-origin",
    }).catch((error) => {
      console.warn("ScopeIQ sync reconcile failed", error)
      return null
    })

    if (!response?.ok) return
    const html = await response.text().catch((error) => {
      console.warn("ScopeIQ sync reconcile failed", error)
      return ""
    })
    if (html.trim()) Turbo.renderStreamMessage(html)
  }
}
